import React from 'react'

import { oneOf } from 'prop-types'

import { PROMO_SLOT } from 'Pods/SearchPage/Shared/Tracking/constants'

import AiCard from './Components/AiCard/AiCard'
import FreelancerCard from './Components/FreelancerCard/FreelancerCard'

function PromoCards({ slot }) {
  return (
    <div className="promo-cards">
      <AiCard slot={slot} index={1} />
      <FreelancerCard slot={slot} index={2} />
    </div>
  )
}

PromoCards.propTypes = {
  slot: oneOf(Object.values(PROMO_SLOT)).isRequired,
}

export default PromoCards
